<template>
  <div class="account-tab-item">
    <div class="account-tab-item__head-mob" v-if="isMob"></div>
    <table class="account-tab-item__table" v-if="!isMob">
      <thead>
        <tr>
          <th>
            <div>{{$tResumeList('Photo')}}</div>
          </th>
          <th>
            <div>{{$tResumeList('Interesting vacancies')}}</div>
          </th>
          <th>
            <div>{{$tResumeList('Updated')}}</div>
          </th>
          <th>
            <div>{{$tResumeList('Sent')}}</div>
          </th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <ResumeTabItemMyRow/>
      </tbody>
    </table>

    <div v-else class="account-tab-item__group">
      <ResumeTabItemMyRow is-mob/>
    </div>

  </div>
</template>

<script>

  import ResumeTabItemMyRow from '@/components/resumeList/ResumeTabItemMyRow'
  export default {
    name: 'ResumeTabItemMy',
    components: {ResumeTabItemMyRow},
    props: {
      isMob: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style>

</style>
